export const LogscordPublicApiMountPath = "/api/public";
export const LogscordPublicApiRoutePaths = {
    trust: "/trust",
    servers: "/servers",
    server: "/servers/:serverRef",
    serverHistory: "/servers/:guildId/history",
    articles: "/:locale/articles",
    article: "/:locale/articles/:slug",
    team: "/team",
};
function withPublicApiMount(path) {
    return `${LogscordPublicApiMountPath}${path}`;
}
export const LogscordPublicApiUrls = {
    trust: withPublicApiMount(LogscordPublicApiRoutePaths.trust),
    servers: withPublicApiMount(LogscordPublicApiRoutePaths.servers),
    team: withPublicApiMount(LogscordPublicApiRoutePaths.team),
    articles(localeCode) {
        return withPublicApiMount(`/${localeCode}/articles`);
    },
    article(slug, localeCode) {
        return withPublicApiMount(`/${localeCode}/articles/${encodeURIComponent(slug)}`);
    },
    server(serverRef) {
        return withPublicApiMount(`/servers/${encodeURIComponent(serverRef)}`);
    },
    serverHistory(guildId) {
        return withPublicApiMount(`/servers/${encodeURIComponent(guildId)}/history`);
    },
};
//# sourceMappingURL=api.js.map